// extracted by mini-css-extract-plugin
export default {"component":"TopSlider__component--ig-M_T7p","center":"TopSlider__center--ig-c8vnG","slide":"TopSlider__slide--ig-gLVV6"};